import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';

import PikabuLogo from '../../assets/svg/pikabu.svg';

import classes from './header.module.scss';

import { ShareBlock } from '@/components/ShareBlock/ShareBlock';
import { analytics, AnalyticsShow, AnalyticsClick, prepareUrl } from 'src/utils/analytics';
import { ThemeSelector } from '@/components/UI/ThemeSelector/ThemeSelector';
import { TagList } from '@/components/UI/TagList/TagList';
import { useStorage } from '@/models/Storage';
import useMobile from '@/hooks/useMobile';

export default observer(function Header() {
    const headerRef = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const { activeStory } = useStorage();
    const mobile = useMobile();
    let storiesPixelShow = false;

    const onScroll = () => {
        const header = headerRef.current;
        const target = document.querySelector('.js-tag-target');
        if (header && target) {
            setExpanded(target.getBoundingClientRect().y <= 82);
            if (!storiesPixelShow && target.getBoundingClientRect().y <= 82) {
                analytics(AnalyticsShow.StoriesBlock);
                storiesPixelShow = true;
            }
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', onScroll);
        onScroll();
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <header
            ref={headerRef}
            className={clsx(classes.header, (expanded || activeStory) && classes.expanded)}
            suppressHydrationWarning
        >
            <div className={clsx('container', classes.container)}>
                <div className={classes.logoBlock}>
                    <a
                        href={prepareUrl(AnalyticsClick.PikabuLogo)}
                        target={'_blank'}
                        rel={'noopener noreferrer'}
                    >
                        <PikabuLogo className={classes.pikabuLogo} />
                    </a>
                    {!mobile && <ShareBlock foldable result={false} />}
                </div>

                {mobile && <ShareBlock foldable result={false} />}
                <ThemeSelector />
            </div>

            {(expanded || activeStory) && (
                <div className={clsx('container', classes.container)}>
                    <TagList foldable={mobile} />
                </div>
            )}
        </header>
    );
});
